import {
  NavLink as RouterLink,
  matchPath,
  useLocation
} from 'react-router-dom';
import PropTypes from 'prop-types';
import { ListItem, Button } from '@mui/material';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';

import Collapsable from './Collapsable';

const NavItem = ({
  href,
  icon: Icon,
  title,
  collapsable = false,
  open = false,
  handleClick,
  ...rest
}) => {
  const location = useLocation();
  const active = href
    ? !!matchPath(
        {
          path: href,
          end: false
        },
        location.pathname
      )
    : false;

  return (
    <ListItem
      disableGutters
      sx={{
        display: 'flex',
        py: 0
      }}
      {...rest}
      onClick={() => collapsable && handleClick()}
    >
      <Button
        component={RouterLink}
        sx={{
          color: 'text.secondary',
          fontWeight: 'medium',
          justifyContent: 'flex-start',
          letterSpacing: 0,
          py: 1.25,
          textTransform: 'none',
          width: '100%',
          transition: '.2s',
          ...(active && {
            backgroundColor: 'primary.main',
            color: 'white',

            ':hover': {
              backgroundColor: 'primary.main',
              color: 'white'
            }
          }),
          '& svg': {
            mr: 1
          },
          '& .MuiButton-label': {
            justifyContent: 'flex-start'
          }
        }}
        style={{
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-start'
        }}
        to={href}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: collapsable ? 'column' : 'row'
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {Icon && (
              <img
                src={Icon}
                alt={'something'}
                style={active ? { filter: 'brightness(0) invert(1)' } : {}}
                height={'20'}
              />
            )}
            <span style={{ marginLeft: '12px', fontSize: '1rem' }}>
              {title}
            </span>
            {collapsable ? open ? <ExpandLess /> : <ExpandMore /> : null}
          </div>
          <div>{collapsable ? <Collapsable open={open} /> : null}</div>
        </div>
      </Button>
    </ListItem>
  );
};

NavItem.propTypes = {
  href: PropTypes.string,
  icon: PropTypes.elementType,
  title: PropTypes.string
};

export default NavItem;
